import React, { forwardRef } from 'react';
/**
 * Shared checkbox input with label.
 *
 * Uses `forwardRef` to allow parent components to imperatively focus or measure
 * the underlying `<input type="checkbox">`.
 *
 * Styling is provided by `./Checkbox.scss`.
 */
import './Checkbox.scss';

export type CheckboxProps = {
  id: string;
  checked: boolean;
  text: string;
  onChange: () => void;
  disabled?: boolean;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { id, checked, text, onChange, disabled }: CheckboxProps,
    ref
  ): JSX.Element => {
    return (
      <div className='checkbox-container'>
        <div className='checkbox-div'>
          <input
            ref={ref}
            type='checkbox'
            id={id}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            name={id}
          />
        </div>
        <label className='checkbox-label' htmlFor={id}>
          {text}
        </label>
      </div>
    );
  }
);

export default Checkbox;
